import { InvalidOperationException } from "./error";
export const BEST_DAYS_TO_VISIT_OPTIONS = [
    { value: "sun", label: "Sun" },
    { value: "mon", label: "Mon" },
    { value: "tue", label: "Tue" },
    { value: "wed", label: "Wed" },
    { value: "thu", label: "Thu" },
    { value: "fri", label: "Fri" },
    { value: "sat", label: "Sat" },
];
export const BEST_TIME_TO_CONTACT_OPTIONS = [
    { value: "morning", label: "Morning" },
    { value: "midday", label: "Midday" },
    { value: "afternoon", label: "Afternoon" },
];
export const verifyValidBestDaysToVisit = (values) => {
    const invalid = values.filter(value => !BEST_DAYS_TO_VISIT_OPTIONS.some(option => option.value === value));
    if (invalid.length > 0) {
        throw new InvalidOperationException(`Invalid best days to visit: ${invalid.join(", ")}`);
    }
};
export const verifyValidBestTimeToContact = (values) => {
    const invalid = values.filter(value => !BEST_TIME_TO_CONTACT_OPTIONS.some(option => option.value === value));
    if (invalid.length > 0) {
        throw new InvalidOperationException(`Invalid best time to contact: ${invalid.join(", ")}`);
    }
};
//# sourceMappingURL=visit-preference-options.js.map